export const showTitleWithDots = (e, value, basedOnHeight = true) => {
  let childSize, itemSize;

  if (basedOnHeight) {
    childSize = e.currentTarget.childNodes[0].offsetHeight;
    itemSize = e.currentTarget.offsetHeight;
  } else {
    childSize = e.currentTarget.childNodes[0].offsetWidth;
    itemSize = e.currentTarget.offsetWidth;
  }
  if (childSize > itemSize) {
    e.target.title = value;
  } else {
    e.target.title = "";
  }
};
